export enum ErrorCodes {
  ServiceCategoriesCode = '4001',
  AlreadyExist = 2,
  MechanicCode = '4004',
  InvalidIdCode = '4004',
  CompetenceCode = '4004',
  MechanicShiftCode = '4004',
  MechanicNotAdd = '4007',
  InvalidMechanicId = '4004',
  ServicecategoriesNotFound = '4002',
  RentalCarAlreadyAdded = 2,
  SuccessCode = 200,
  DataNotFoundErrorCode = 404,
  InterrnalError = 404,
  MechanicLunchShiftErrorCode = '7007',
  MechanicLunchShiftErrorMessage = 'Start time should not be greater than or equal to  End time',
  NotFound = 400,
  RentalVehicleNotFound = '4004',
  DuplicateEntry = '409',
  LicensePlateNotFoundErrorCode = '1001',
  ParamNotFoundErrorCode = '1000',
  InvalidOTP = '1011',
  OTPTimeOut = '1012',
  CustomerNotFoundErrorCode = '1007',
  DealerOpeningHoursNotFoundErrorCode = '1067',
  DealerHolidayListNotFound = '1069',
  DealerAdditionalServiceNotFound = '1077',
  CreateAppointmentErrorCode = '1071',
  CountryCodeNotFoundErrorCode = '1777',
  LicensePlateAlreadyExistsErrorCode = '1047',
  EmailAlreadyExistsErrorCode = '1073',
  NameAlreadyExistsErrorCode = '1078',
  AdUserIdAlreadyExistsErrorCode = '1076',
  UserCreationLimitExceed = '1000',
  MechanicEmailExistsCode = '1111',
  PartNotfound = '7777',
  ParamInvalid = '400',
  ErrorCode = '500',
  DataNotFound = '404',
  RolesNotUpdated = '1074',
  SlotNotAvailble = '1',
  AddAppointMentError = '1007',
  CustomerVehicleNotFound = '1008',
  CustomerMappingError = '1009',
  log = "1010",
  ServiceUnavailable = "ServiceUnavailable",
  NoContent = "NoContent",
  DealerBreak = "4008",
  UserBreak = "4009"
}

export enum MimeType{
  PNG='image/png',
  JPEG='image/jpeg',
  JPG='image/jpg' ,
  GIF='image/gif',
  SVG='image/svg+xml',
  PDF='application/pdf',
  MP4 ='video/mp4',
  QUICKTIME = 'video/quicktime'
}

export enum PdfType {
  OrderConfirmationWithPrice = 1,
  OrderConfirmationWithoutPrice = 2,
  OfferWithPrice = 3,
  Invoice = 4
}

export enum BrandCodes {
  Mercedes = 'MER',
  Peugeot = 'PEU',
  Kia = 'KIA',
  Citroën = 'CIT',
  Audi = 'AUD',
  BMW = 'BMW'
}

export const enum TransmissionType {
  AutomaticGearBox = 65,
  ManualGearBox = 77,
  AutomatedGearBox = 81
}

export enum ServiceType {
  AFXService = 0,
  TecRMIService = 1,
  TecRMIAdditionalService = 2
}

export enum BrandName {
  MER = 'Mercedes',
  PEU = 'Peugeot',
  KIA = 'Kia',
  CIT = 'Citroën',
  AUD = 'Audi',
  BMW = 'BMW'
}
export enum CurrencyCodes {
  USD = 'USD',
  INR = 'INR',
  GBP = 'GBP',
  AUD = 'AUD',
  CAD = 'CAD',
  EUR = 'EUR',
  NOK = 'NOK'
}
export enum CultureCodes {
  EN_US = 'en-US',
  NB_NO = 'nb-NO',
  FI_FI = 'fi-FI',
  NL_NL = 'nl-NL',
  DE_DE = "de-DE"
}
export enum CultureDateFormat {
  EN_US = 'm/d/Y',
  NB_NO = 'd.m.Y',
  FI_FI = 'd.m.Y',
  NL_NL = 'd-m-Y',
  DE_DE = "d.m.Y"
}

export enum WorkOrderStatus {
  WaitingForCustomer = '1',
  CarArrived = '2',
  MechanicStarted = '3',
  ChecklistRecorded = '4',
  MechanicDone = '5',
  WorkDone = '6',
  InvoiceReady = '7',
  WorkRequest = '8',
  InvoicePaid = '9',
  Closed = '10',
  Cancelled = '11',
  Prepared = '12',
  OnHold='13'
}
export enum AppointmentStatus {
  Confirmed = 1,
  CheckedIn = 2,
  WorkStarted = 3,
  Completed = 4,
  Cancelled = 5,
  InvoiceReady = 6,
  Closed = 7,
  Pending = 9,
  CarArrived= 10,
  InProgress = 11
}
export enum AppointmentType{
  OFFER = 'Quote',
  ORDER = 'Order'
}
export enum AppointmentStatusName {
  Confirmed = 'Confirmed',
  CheckedIn = 'Checked-In',
  WorkStarted = 'Work Started',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  InvoiceReady = 'Invoice Ready',
  Closed = 'Closed',
  Pending = 'Pending',
  CarArrived= 'Car Arrived',
  InProgress = 'In Progress'
}
export enum ToastrMessages {
  ServiceCategoriesCode = 'Service Categories not found.',
  ServicecategoriesNotFound = 'Service category not found.',
  EditServiceCategory = 'Service category updated.',
  AddedServiceCategories = 'Service category added.',
  AlreadyAddedServiceCategory = 'Service category already added.',
  DeletedServiceCategory = 'Service category deleted.',
  DeletedRentalCar = 'Rental car deleted.',
  DeleteService = 'Service deleted.',
  AddedRentalCar = 'Rental car added.',
  RentalCarEdited = 'Rental car edited',
  RentalCarEditInternalError = 'Rental Car Is Not Edited Due To Internal Error.',
  ReantalCarAlreadyAdded = 'Rental car alredy added.',
  ErrorWarningForValue = 'Provided values are not proper. Please check again',
  ErrorMessage = 'error occured',
  RentalCarNotFound = 'Rental car not exist.',
  VehicleNotFound = 'Vehicle not found.',
  EditVehicle = 'Vehicle updated.',
  CustomerNotFoundAddWarning = 'Customer details are not found.',
  LicencePlateRequired = 'Licence plate is required.',
  DetailsAdded = 'Your Details has been added successfully.',
  DealerOpeningHoursNotFound = 'Dealer Opening Hours not available.',
  CreateAppointmentFailed = 'Appointment not created. Please try again later.',
  CustomerVehilceAddFailed = 'Some error occurred. Please try again later.',
  LicensePlateAlreadyExistsErrorMessage = 'License plate already exists.',
  ParamsNotFound = 'Params Not Found',
  DealerAdded = 'Dealer Added Successfully.',
  DealerWorkingHoursUpdated = 'Dealer Working Hours Updated Successfully.',
  DealerWorkingHoursUpdateFailed = 'Update Dealer Working Hours Failed. Please try again later.',
  DealerEdit = 'Dealer Updated Successfully.',
  DealerAddedFailed = 'Add Dealer Failed. Please try again later.',
  DealerEditFailed = 'Edit Dealer Failed. Please try again later.',
  EmailAlreadyExist = 'Email Already Exists.',
  NameAlreadyExist = 'Name Already Exists.',
  PartNotfound = 'Part not found',
  EditParts = 'Parts updated.',
  SaveMechanicBooking = 'Mechanic Booking Saved.',
  NoMechanicBooked = 'Appointment is already booked for same mechanic or mechanic on leave/business absence.',
  NoMechanicAvailable = 'No mechanic available on the given date',
  ParamInvalid = 'Invalid value for Parameter',
  MechanicBookingDeleted = 'Mechanic Booking Deleted.',
  MechanicBlockingDeleted = 'Mechanic Blocking Deleted.',
  DealerTaxDetailsUpdated = 'Dealer Tax Details Updated.',
  DealerTaxDetailsUpdateFailed = 'Dealer Tax Not Updated. Please try again later.',
  MinutesValidation = 'Minutes should be less than 60 and multiple of 15',
  DealerServiceAdded = 'Dealer Service Added Successfully.',
  DealerServiceAddFailed = 'Dealer Service Add Failed. Please try again later.',
  DealerServiceUpdated = 'Dealer Service Update Successfully.',
  DealerServiceUpdateFalied = 'Dealer Service Update Failed. Please try again later.',
  DealerServiceDeleted = 'Dealer Service Deleted Successfully.',
  DealerServiceDeleteFailed = 'Dealer Service Delete Failed. Roles not updated.',
  AppointmentPlanningServiceNotAddedValidation = 'Please Add Atleast One Service to Appointment.',
  RolesNotUpdatedErrorMessage = 'Roles not updated.Roles not updated.',
  RolesNotUpdated = 'Role Rights updated.',
  SlotNotAvailble = 'The slot you have chosen is not available. Please choose another slot and try again',
  PaymentSuccess = "Payment Completed Successfully.",
  PaymentFailed = "Payment Checkout Failed. Please try again later.",
  PaymentFeatureError = "Payment service is temporarily unavailable.",
  PaymentConfigError = "Payment service is temporarily unavailable.",
  UnAuthorizedError = "You are not authorized to access all menus. Please contact the system administrator for more detail.",
  CustomerDealerAssociationNotFound = "Customer Dealer Association Not Found."
}

export enum IsDWOActive{
  isDWOActive = 1
}
export enum Language {
  English = "en-US",
  Dutch = "nl-NL",
  Norwegian = "nb-NO"

}
export enum TemplateType {
  /// <summary>
  /// The all
  /// </summary>
  All = 0,

  /// <summary>
  /// The email
  /// </summary>
  Email = 1,

  /// <summary>
  /// The SMS
  /// </summary>
  Sms = 2,

  /// <summary>
  /// The push notification
  /// </summary>
  PushNotification = 3,

  /// <summary>
  /// The notification
  /// </summary>
  Notification = 4
}

export enum TaxType {
  Personnel = 1,
  Material = 2
}

export enum LanguageCode {
  "en-US" = 1,
  "de-DE" = 2,
  "nl-NL" = 3,
  "fr-FR" = 4,
  "nn-NO" = 5
}

export enum DocumentsType{
  Pdf=1,
  Excel=2
}

export enum WeekDays {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}

export const enum UserRoles {
  SuperAdmin = 1,
  Admin = 2,
  DealerAdmin = 3,
  Mechanic = 4,
  Reception = 5,
  CDSS = 6,
  ServiceAdvisor =7,
  SuperUser = 8
}

export const enum ModuleNameList {
  Configurations = 'Configurations',
  Dashboard = 'Dashboard',
  DealerSetup = 'Dealer Setup',
  DWO = 'DWO',
  Planner = 'Planner'
}


export const enum ModuleNames {
    Brand = 30,
    Dashboard = 2,
    DealerDetails = 3,
    DealerHoliday = 4,
    Reception = 38,
    DealerService = 5,
    Mechanic = 6,
    Service = 7,
    ServiceCategory = 8,
    Vehicle = 9,
    RentalVehicle = 10,
    Appointment = 11,
    SpecialTools = 12,
    DealerSpecialTools = 13,
    Template = 14,
    Parts = 15,
    DealerParts = 16,
    TimeStamp = 17,
    AutoKey = 18,
    ChecklistManagement = 19,
    DiagnoseChecklist = 20,
    TechnicalManual = 21,
    MechanicTimecode = 22,
    DealerKeydropLocation = 23,
    DiagnoseTemplate = 24,
    UploadParkingImage = 25,
    RolesRights = 26,
    Customer = 27,
    StatusConfiguration = 28,
    competence = 32,
    Package = 31,
    LogofSmsEmailSent = 33,
    Feature = 34,
    UserClockInOut = 112,
    AppointmentStatusConfig = 39,
    Planning = 40,
    ServiceAdvisor = 41,
    Campaigns = 42,
    TargetedGroup = 43,
    CampaignTemplate = 44,
    SMSTemplate = 45,
    SyncJobs = 47,
    DMSDefaultValues = 48,
    DMSSyncFailedlog = 49,
    AFXSyncFailedlog = 52,
    WidgetAppointment = 51,
    CustomerWaiting = 53,
    PickupDropoff = 54,
    ActiveUser = 55,
    CustomerPickDrop = 60,
    ApplicationVersionDetails = 56,
    Accounts = 57,
    HeaderNotification = 58,
    MechanicClockingReport=59,
    Labor = 63,
    ContactUser = 64,
    AppointmentLock = 68,
    DMSSyncSchedulerlog = 71,
    MechanicEfficiencyReport = 72,
    MechanicReport = 73,
    Preferences = 78,
    Promotions = 80,
    Category = 83,
    ServiceMechanicWiseReport =74,
    ArchivedAppointment = 75,
    WarningLights = 79,
    VehicleDelete = 86,
    CustomerDelete = 84,
    ActionType = 76,
    AutomaticUpdates = 87,
    AgentEfficiency = 100,
    CallDealerLogs = 101,
    CheckInUsage = 99,
    CustomerDocumentUpload = 98,
    MechanicAccuracyReport=102,
    DeletedPlanning=104,
    UserViseAppointment=105,
    CdssAppointment=108,
    TimeStampReport=111,
    UserStampReport=113,
    PartSalesPriceCalculation = 114,
    LaborChargingGroupPrice = 115,
    IncomingAndOutgoingCalls = 117,
    ChangePaymentMethod = 118,
    TotalSoldHoursReport = 119,
    SmartPlannerExceptionLog = 120,
    AllowInvoiceFeature = 121,
    ShowDealerWithNoAppointment = 122,
    WorkOrderStatusReport=123,
    TowedInReport=124,
    AdditionalWorkReport=125,
    AllowInvoiceDownload = 127,
    WOTimeStampReport=164,
    SyncFailAppointment=165
}

export const enum FeatureCode{
  DWO = 'DWO',
  RenatlCar = 'RenatlCar',
  OTP = 'OTP',
  ShowLocationCode = 'ShowLocationCode',
  OFFER = 'OFFER',
  SSM = 'SSM',
  SST = 'SST',
  DMS = 'DMS',
  CRM = 'CRM',
  ThirdPartyAPI = 'ThirdPartyAPI',
  GWoNoPlannerSide = 'GWoNoPlannerSide',
  GCuNoPlannerSide = 'GCuNoPlannerSide',
  GRentalCar = 'GRentalCar',
  AllowCompanyCreation = 'AllowCompanycreation',
  AllowAccount = 'AllowAccounts',
  AllowQuicksearch = 'AllowQuickSearch',
  RTDSA = 'RTDSA',
  RTDSV = 'RTDSV',
  RTDSC = 'RTDSC',
  AddAccount = 'AllowAddAccounts',
  AddCar = 'AllowAddCarFromWidget',
  PARTS = 'PARTS',
  TCLINK = 'T&CLINK',
  TCDATA = 'T&CDATA',
  WidgetVehicleDMSSearch = 'WidgetVehicleDMSSearch',
  Tax = 'TAX',
  TecRMI = 'TecRMI',
  PickupDropoff = 'PickUpDropOff',
  SyncJobs = 'SyncJobs',
  SpecialTool='SpecialTool',
  ShareBox = 'ShareBox',
  Pbx = 'Pbx',
  RTWRA = 'RTWRA',
  EnableCookieConsent = 'EnableCookieConsent',
  OnlineCheckin = 'OnlineCheckin',
  PredefinedChecklist = 'PredefinedCheckList',
  ArchiveAppointment = 'ArchiveAppointment',
  RTDSS = 'RTDSS',
  DeleteDmsAppointment = 'DeleteDmsAppointment',
  DocumentPartStatus = 'DocumentPartStatus',
  AppointmentLock = 'AppointmentLock',
  DmsSlots = 'DmsSlots',
  DmsPackageSync = 'DmsPackageSync',
  Scrive = 'Scrive',
  RTDSL = "RTDSL",
  DmsAppointment = "DmsAppointment",
  ShiftAppointment= 'ShiftAppointment',
  AddBrands = 'AddBrands',
  GoogleTagManager = 'GoogleTagManager',
  PlannedAndAvailableHours = 'PlannedAndAvailableHours',
  Romnas = 'Romnas',
  CheckInVideoLink = "CheckInVideoLink",
  WarningLight='WarningLight',
  AddRole = 'AddRole',
  Preferences ='Preferences',
  Promotions='Promotions',
  AgentEfficiencyReport = 'AgentEfficiencyReport',
  CallDealerLogsReport = 'CallDealerLogsReport',
  CheckInUsageReport = 'CheckInUsageReport',
  AllowCustomerUploadDoc = 'AllowCustomerUploadDoc',
  HideDashboardFeatures = 'HideDashboardFeatures',
  ReasonForDeletePlanning = 'ReasonForDeletePlanning',
  CustomerManualNotify = 'CustomerManualNotify',
  AutomaticUpdates = 'AutomaticUpdates',
  WidgetAppointmentTimer = 'WidgetAppointmentTimer',
  AllowPlanningOnLeave = 'AllowPlanningOnLeave',
  DMSService = 'DMSService',
  WCVLS ='WCVLS',//Widget - Customer Verification at last step
  WSSBLP ='WSSBLP', //Widget - Step-1 Search by license plate
  WhatsApp = "LogofWhatsappMessages",
  INVGN = 'INVGN',
  WorkorderTimer = 'WorkorderTimer',
  JobDetailsTimer = 'JobDetailsTimer',
  CentralPart = 'CentralPart',
  UserStampInOut = 'UserStampInOut',
  UserStampReport = 'UserStampReport',
  MapDirection = 'MapDirection',
  GiftCard = 'GiftCard',
  HidePrivacyPolicy = 'HidePrivacyPolicy',
  HideMarketingConcent = 'HideMarketingConcent',
  AllowDealerBrandLaborRate = 'AllowDealerBrandLaborRate',
  IsAllowMediaVisibility = 'IsAllowMediaVisibility',
  OLB = 'OLB',
  RentalCarAsDemand = 'RentalCarAsDemand',
  BlockMechanic = 'BlockMechanic',
  MPO = 'MPO',
  NeedAttention = 'NeedAttention',
  ShowDMSStatus = 'ShowDMSStatus',
  DiscountCode = 'DiscountCode',
  TireHotel = 'TireHotel'
}

export const enum DashboardGridFeatures{
  DMS = "DMS",
  CheckIn = "CheckIn",
  OrderValueInvoiceAmount = "OrderValueInvoiceAmount",
  WorkshopCapacity = "WorkshopCapacity",
  SmartPlanner = "SmartPlanner",
  Widget = "Widget",
  OlbBo = "OlbBo"
}


export const enum CheckListType{
  TYPE_1_CHECKBOX = 1,
  TYPE_2_TEXTBOX = 2,
  TYPE_3_CHECKBOX_TEXTBOX = 3,
  TYPE_4_RADIOBUTTON = 4,
  TYPE_5_RADIOBUTTON_TEXTBOX = 5,
  TYPE_6_RADIOBUTTON_CHECKBOX = 6,
  TYPE_7_RADIOBUTTON_CHECKBOX_TEXTBOX = 7,
  TYPE_8_RADIOBUTTON_COLORED = 8
}

export const enum ClType{
  Generic = 1,
  Diagnose = 2,
  SSM = 3
}

export const enum EntityType{
  Appointment = 'Appointment',
  Vehicle = 'Vehicle',
  Customer = 'Customer',
  Call = 'Call'
}

export const enum AppointmentDay{
TodayAppointment = 'TA',
TomorrowAppointment = 'TOA',
YesterdayAppointment = 'YA',
TodayCheckedInAppointment = 'CTA',
TomorrowCheckedInAppointment = 'CTOA',
TodayNotCheckedInAppointment = 'NCTA',
TomorrowNotCheckedInAppointment = 'NCTOA',
TodayCancelledAppointment = 'CATA',
TomorrowCancelledAppointment = 'CATOA'
}

export enum WOStatus{
  All=0,
  Waitingforcustomer = 1,
  Cararrived = 2,
  Mechanicstarted = 3,
  Checklistrecorded = 4,
  Mechanicdone = 5,
  Workdone = 6,
  Invoiceready = 7,
  WorkRequest = 8,
  InvoicePaid = 9,
  Closed = 10,
  Cancelled = 11,
  Prepared = 12,
  OnHold=13
}

export enum WOStatusName{
  Waitingforcustomer = 'Waiting for customer',
  Cararrived = 'Car arrived',
  Mechanicstarted = 'Mechanic started',
  Checklistrecorded = 'Checklist recorded',
  Mechanicdone = 'Mechanic done',
  Workdone = 'Work done',
  Invoiceready = 'Invoice ready',
  WorkRequest = 'Work Request',
  InvoicePaid = 'Invoice Paid',
  Closed = 'Closed',
  Cancelled = 'Cancelled',
  Prepared = 'Prepared',
}


export const enum WOStatusNo{
  WorkRequest=6,
  Prepared=10,
  Waitingforcustomer=0,
  CarArrived=1,
  MechanicStarted=2,
  MechanicDone=3,
  WorkDone=4,
  InvoiceReady=5,
  InvoicePaid=7,
  Closed=8,
  Cancelled = 9,
}

export const enum Environment{
  BNH='bnh',
  AFX='afx',
  EM='em',
  MG='mg'
}
export enum StatusCode{
  All=0,
  Active=1,
  InActive=2
}

export enum DmsSync{
  All=0,
  Success=1,
  Failed=2
}

export const enum SignalRHubEventType{
  BroadcastNotification = "BroadcastNotification",
  UserNotification = "UserNotification",
  AppointmentUpdated = "AppointmentUpdated",
  UpdateAppointmentStatus = "UpdateAppointmentStatus",
  OnCall = "OnCall",
  DocumentUploaded = "DocumentUploaded",
  AppointmentRemoved = "AppointmentRemoved",
  WarrantySigned = "WarrantySigned",
}
export const enum SignalRHubMethod{
  AddConnection = "AddConnection",
  RemoveConnection = "RemoveConnection",
  GetConnection = "GetConnection",
  AddAppointmentLock = "AddAppointmentLock",
  UnlockAppointmentLock = "UnlockAppointmentLock",
}

export enum DealerList{
  All='All Dealer',
  Failed='2'
}
export enum ShortWeekName {
  Sunday = 'Sun',
  Monday = 'Mon',
  Tuesday = 'Tue',
  Wednesday = 'Wed',
  Thursday = 'Thurs',
  Friday = 'Fri',
  Saturday = 'Sat'
}
export enum SecureStorageKey {
  GetUserDetails = 'GetUserDetails',
}
export enum Tenant {
  AFX = '81ea23af-2b86-40b1-9bf5-26613d44144'
}
export enum RegexKeyCollection{
  Email = '^(?:[-._ÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÅÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓa-zA-Z0-9]+)*@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$',
  CustomerEmail = '(?:[-._ÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÅÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓa-zA-Z0-9]+)*@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$'
}

export enum PaymentType {
  B2C = 'B2C',
  B2B = 'B2B',
  Internal = 'Internal'
}
export enum SourceId {
  Widget = 3,
  Planner = 1,
  Dwo = 2,
  DMS = 4,
  BC = 5,
  DF = 6,
  CRM = 7
}

export enum IntegrationName {
  BusinessCentral = 'Business Central',
  EuroMaster = 'EuroMaster',
  Scrive = 'Scrive',
  ShareBox = 'ShareBox',
  SSM = 'SSM',
  TecRMI = 'TecRMI',
  Telia = 'Telia'
}

export enum HistoryStatus {
    AddAppointment = "Add Appointment",
    UpdateAppointment = "Update Appointment",
    AddMechanic = "Added Planning",
    UpdateMechanic = "Updated Planning",
    AddAdditionalWork = "Added Additional Work",
    MechanicStarted = "Mechanic Started",
    MechanicDone = "Mechanic Done",
    WorkDone = "Work Done",
    DeleteMechanic = "Deleted Planning",
    AddAppoitmentFromWidget = "Added Appointment From Widget",
    ApprovedByServiceAdvisor = "Approved By Service Advisor",
    CheckListAnswer = "Checklist answer",
    UpdateMileage = "Updated Mileage",
    AppoitmentStartJobTimer = "Appointment Job Timer Started",
    AppoitmentStopJobTimer = "Appointment Job Timer Stopped",
    AdditionalWorkApprovedByCustomer = "Additional Work Approved By Customer",
    AdditionalWorkRejectByCustomer = "Additional Work Rejected By Customer",
    VirtualCheckInDoneByCustomer = "CheckIn done by customer",
    CheckInSMSSent = "CheckIn link sent",
    TrackerSMSSent = "Tracker link sent",
    PaymentDone = "Payment Done",
    CustomerKeyPickUp = "Customer Key PickUp",
    CustomerKeyDrop = "Customer Key Drop",
    MechanicKeyDrop = "Mechanic Key Drop",
    MechanicKeyPickUp = "Mechanic Key PickUp",
    MechanicKeyReset = "Mechanic Key Reset",
    ImportFromSSM = "Import From SSM",
    SSMSentVin = "SSM Sent Vin",
    WarrantyDocumentSendToSign = "Warranty Document Send To Sign",
    WarrantyDocumentSigned = "Warranty Document Signed",
    WarrantyDocumentRejected = "Warranty Document Rejected",
    DMSAddAppoitment = 'DMS Add Appointment',
    DMSUpdateAppointment = 'DMS Update Appointment',
    DMSAppoitmentDeleted = 'DMS Appointment Deleted',
    DMSServiceLineDeleted = 'DMS ServiceLine Deleted',
    DMSAddDemand = 'DMS Add Demand',
    DMSEditDemand = 'DMS Edit Demand',
    DMSDeleteDemand = 'DMS Delete Demand',
    DMSAddJobDetails = 'DMS Add JobDetails',
    DMSEditJobDetails = 'DMS Edit JobDetails',
    DMSDeleteJobDetails = 'DMS Delete JobDetails',
    ShiftAppointment = 'Shift Appointment',
    ImportFromRomnas = 'Import From Romnes',
    ImportFromTecRMI = 'Import From TecRMI',
    CarArrived = "Car Arrived",
    AppoitmentStartWOTimer = "Appointment WorkOrder Timer Started",
    AppoitmentStopWOTimer = "Appointment WorkOrder Timer Stopped",
    AppointmentDemandComment = "Appointment demand comment",
    ParkingImageSaved = "Parking Image Updated",
    InternalCommentSaved = "Internal Comment Saved",
    DemandFileUpload = "Demand file Uploaded",
    ChecklistFileUpload = "Checklist file Uploaded",
    AdditionalWorkFileUpload = "Additional work file Uploaded",
    DiagnoseCheckListFileUpload = "Diagnose checkList file Uploaded",
    DemandFileDeleted = "Demand file Deleted",
    ChecklistFileDeleted = "Checklist file Deleted",
    AdditionalWorkFileDeleted = "Additional work file Deleted",
    DiagnoseCheckListFileDeleted = "Diagnose checkList file Deleted",
    OnHold = "On Hold",
    DiagnoseCheckListAnswer="Diagnose checkList answer",
    ParkingImageDeleted = "Parking Image Deleted",
    AdditionalWorkAddDemand = 'Additional Work Demand Added',
    AdditionalWorkDeleteDemand = 'Additional Work Demand Deleted',
    AdditionalWorkAddJobDetails = 'Additional Work Job Details Added',
    AdditionalWorkDeleteJobDetails = 'Additional Work Job Details Deleted',
    AddDemand = "Demand Added",
    DeleteDemand = "Demand Deleted",
    AddJobDetails = "Job Details Added",
    DeleteJobDetails = "Job Details Deleted",
    RentalCarUpdated = "Rental Car Updated",
    DeliveryTimeUpdated = "Delivery Time Updated",
    FinishTimeUpdated = "Finish Time Updated",
    WorkOrderStatusUpdated = "Workorder Status Updated",
    IsCustomerWaitingUpdated ="Customer Waiting Updated",
    MileageUpdated ="Mileage Updated",
    InternalCommentAdded = "Internal Comment Added",
    CustomerUploadedDocument = 'Uploaded Document',
    UpdateJobStatus="Update Job Status",
    WorkorderTimeCorrection="Workorder Time Correction",
    JobTimeCorrection="Job Time Correction",
    DeletedTimeSummry="Stamp summary deleted",
    WaitingFromCustomer = "Waiting For Customer",
    InvoiceGenerated ="Invoice Generated",
    AppoitmentStartJobDetailTimer = "Appoitment JobDetail Timer Start",
    AppoitmentStopJobDetailTimer = "Appoitment JobDetail Timer Stop",
    JobDetailTimeCorrection="Job Detail Time Correction",
    ContactNameUpdated = "Contact Name Updated",
    ContactNumberUpdated = "Contact Number Updated",
    InternalCommentUpdated = "Internal Comment Updated",
    InformationUpdated = "Information Updated",
    CampaignServiceUpdated = "Campaign Service Updated",
    AppointmentDeleted = "Appointment Deleted",
    PlanningDeletedOnCancelStatus = "Planning Deleted On Cancel Appointment",
    ImportSstRequest = "Created new appointment in SST Triage",
    ExportSstRequest = "Exported appointment from SST Triage",
    TechnicianUpdatedIntoSst = "Updated Technician into SST Triage",
    TechnicianDeletedIntoSst = "Deleted Technician into SST Triage",
    MediaVisibilityUpdated = "Media Visibility Updated",
    ShareBoxInformationSent = "Sharebox information sent",
    DemandStatusUpdatedIntoSst = "Updated Demand Status into SST Triage",
    CustomerPickupTimeUpdated = "Customer Pickup Time updated",
    CustomerDropTimeUpdated = "Customer Drop time updated",
    CreateOfferInMPO = "Create Offer In MPO",
    GetOfferFromMPO = "Get Offer From MPO",
    DemandSentForCustomerApproval = "SMS Sent To Customer For Additional Work Approval",
    AFXDemandSyncToSST = "AFX Demand Sync Succefully To SST",
    WidgetAppointmentRequest = "Widget Appointment Request Data",
    KeyPickupWithoutPayment = "Allow Key Pickup Without Payment",
    CustomerUpdated = "Customer Updated",
    DiscountCodeUpdated = "Discount Code Updated",
    DSODiagnoseUpdate = "DSO Diagnose Updated",
    serviceAdvisorUpdated = "Service Advisor Updated",
    DocumentPartStatusUpdated = "Document Part Status Updated"
}

export enum HistoryStatusId {
    AddAppointment = 1,
    UpdateAppointment = 2,
    AddMechanic = 3,
    UpdateMechanic = 4,
    AddAdditionalWork = 5,
    MechanicStarted = 6,
    MechanicDone = 7,
    WorkDone = 8,
    DeleteMechanic = 9,
    AddAppoitmentFromWidget = 10,
    ApprovedByServiceAdvisor = 11,
    CheckListAnswer = 12,
    UpdateMileage = 13,
    AppoitmentStartJobTimer = 14,
    AppoitmentStopJobTimer = 15,
    AdditionalWorkApprovedByCustomer = 16,
    AdditionalWorkRejectByCustomer = 17,
    VirtualCheckInDoneByCustomer = 18,
    CheckInSMSSent = 19,
    TrackerSMSSent = 20,
    PaymentDone = 21,
    CustomerKeyPickUp = 22,
    CustomerKeyDrop = 23,
    MechanicKeyDrop = 24,
    MechanicKeyPickUp = 25,
    MechanicKeyReset = 26,
    ImportFromSSM = 27,
    SSMSentVin = 28,
    WarrantyDocumentSendToSign = 29,
    WarrantyDocumentSigned = 30,
    WarrantyDocumentRejected = 31,
    DMSAddAppoitment = 32,
    DMSUpdateAppointment = 33,
    DMSAppoitmentDeleted = 34,
    DMSServiceLineDeleted = 35,
    DMSAddDemand = 36,
    DMSEditDemand = 37,
    DMSDeleteDemand = 38,
    DMSAddJobDetails = 39,
    DMSEditJobDetails = 40,
    DMSDeleteJobDetails = 41,
    ShiftAppointment = 42,  
    ImportFromRomnas = 43,
    ImportFromTecRMI = 44,
    CarArrived=48,
    AppoitmentStartWOTimer=49,
    AppoitmentStopWOTimer = 50,
    AppointmentDemandComment=51,
    ParkingImageSaved=52,
    InternalCommentSaved=53,
    DemandFileUpload=54,
    ChecklistFileUpload=55,
    AdditionalWorkFileUpload=56,
    DiagnoseCheckListFileUpload = 57,
    OnHold=58,
    DemandFileDeleted = 59,
    ChecklistFileDeleted = 60,
    AdditionalWorkFileDeleted = 61,
    DiagnoseCheckListFileDeleted = 62,
    DiagnoseCheckListAnswer = 63,   
    ParkingImageDeleted=64,
    AdditionalWorkAddDemand = 65,
    AdditionalWorkDeleteDemand = 66,
    AdditionalWorkAddJobDetails = 67,
    AdditionalWorkDeleteJobDetails = 68,
    DeleteDemand=70,
    DeleteJobDetails=72,
    AddJobDetails=71,
    DeliveryTimeUpdated=74,
    RentalCarUpdated=73,
    WorkOrderStatusUpdated=76,
    FinishTimeUpdated = 75,
    MileageUpdated =78,
    IsCustomerWaitingUpdated = 77,
    InternalCommentAdded = 79,
    AddDemand = 80,
    CustomerUploadedDocument = 69,
    UpdateJobStatus=84,
    WorkorderTimeCorrection=81,
    JobTimeCorrection=82,
    DeletedTimeSummry=83,
    WaitingFromCustomer=85,
    InvoiceGenerated = 86,
    AppoitmentStartJobDetailTimer = 87,
    AppoitmentStopJobDetailTimer = 88,
    JobDetailTimeCorrection = 89,
    ContactNameUpdated = 90,
    ContactNumberUpdated = 91,
    InternalCommentUpdated = 92,
    InformationUpdated = 93,
    CampaignServiceUpdated = 94,
    AppointmentDeleted = 95,
    PlanningDeletedOnCancelStatus = 96,
    ImportSstRequest = 97,
    ExportSstRequest = 98,
    TechnicianUpdatedIntoSst = 99,
    TechnicianDeletedIntoSst = 100,
    MediaVisibilityUpdated = 101,
    DemandStatusUpdatedIntoSst = 102,
    ShareBoxInformationSent = 103,
    CreateOfferInMPO = 104,
    GetOfferFromMPO = 105,
    DemandSentForCustomerApproval = 106,
    CustomerDropTimeUpdated = 107,
    CustomerPickupTimeUpdated = 108,
    AFXDemandSyncToSST = 109,
    WidgetAppointmentRequest = 110,
    KeyPickupWithoutPayment = 111,
    CustomerUpdated = 125,
    DiscountCodeUpdated = 126,
    DSODiagnoseUpdate = 127,
    serviceAdvisorUpdated = 128,
    DocumentPartStatusUpdated = 129
}

export enum Application
{
         /// <summary>
            /// The Admin
            /// </summary>
            Admin = 1,

            /// <summary>
            /// The CheckIn
            /// </summary>
            CheckIn = 2,

            /// <summary>
            /// The Reception
            /// </summary>
            Reception = 3,

            /// <summary>
            /// The StatusTracker
            /// </summary>
            StatusTracker = 4,

            /// <summary>
            /// The DWO
            /// </summary>
            DWO = 5,

            /// <summary>
            /// The Widget
            /// </summary>
            Widget = 6,
            /// <summary>
            /// The Scrive
            /// </summary>
            Scrive = 7,

            /// <summary>
            /// The ShareBox
            /// </summary>
            ShareBox = 8,

            /// <summary>
            /// The Widget
            /// </summary>
            DMS = 9,

}

export enum CustomerHistoryId{
  Email = 1,
  MobileNo=2,
  FirstName = 3,
  LastName = 4,
  Address1 = 5,
  Zipcode = 6,
  City = 7,
  Country = 8,
  IsMarketingConsent = 9, 
  IsSms = 10,
  IsPhone = 11,
  IsEmail = 12,
  CustomerGroup = 13,
  CustomerTypeId = 14,
  PreferredDealerId = 15,
  PaymentMethodCode = 16,
  PaymentTermsCode = 17,
  ReminderTermsCode = 18,
  isCompanyNameChanged = 19
}

export enum CustomerHistoryStatus{
  Email = "Email",
  MobileNo="Mobile No",
  FirstName = "First Name",
  LastName = "Last Name",
  Address1 = "Address Line 1",
  Zipcode = "Postcode",
  City = "City",
  Country = "Country",
  IsMarketingConsent = "Marketing Consent", 
  IsSms = "Sms Consent",
  IsPhone = "Phone Consent",
  IsEmail = "Email Consent",
  CustomerGroup = "Customer Group",
  CustomerTypeId = "Customer Type",
  PreferredDealerId = "Dealer",
  PaymentMethodCode = "Payment Method",
  PaymentTermsCode = "Payment Terms",
  ReminderTermsCode = "Reminder Terms",
  isCompanyNameChanged = "Company Name"
}

export enum LeaveOptionType {
  Personal = 1,
  Business = 2
}

export enum CustomLeaveOptionType {
  Sykemelding = 1,
  Egenmelding = 2,
  Kurstrening = 3,
  Ferie = 4,
  Permisjon = 5
}

export enum LeaveType {
  DateRange = 1,
  MultiDay = 2,
  Recurring = 3
}

export const enum ApointmentModuleNames {
  WorkOrder = 1,
  AdditionalWork = 2,
  Planning = 3,
  DWO = 4,
  Communication = 5,
  Parking = 6,
  WorkOrderHistory = 7,
  Documents = 8,
  Updates = 10,
  Invoie = 9,
  ShareboxLog = 12,
  // Removed to stop rendering of Whatsapp integration
  // WhatsApp = 11
}

export enum TemplateField {
  APPOINTMENTCREATEDDATE = "lblTfAppointmentCreatedDate",
  APPOINTMENTCREATEDTIME = "lblTfAppointmentCreatedTime",
  APPOINTMENTDATE = "lblTfAppointmentDate",
  APPOINTMENTTIME = "lblTfAppointmentTime",
  BILLTOCUSTOMEREMAIL = "lblTfBillToCustomerEmail",
  BILLTOCUSTOMERNAME = "lblTfBillToCustomerName",
  BILLTOMOBILECODE = "lblTfBillToMobileCode",
  BILLTOMOBILENO = "lblTfBillToMobileNo",
  BRANDCODE = "lblTfBrandCode",
  BRANDNAME = "lblTfBrandName",
  CARTYPE = "lblTfCarType",
  CHECKINDATE = "lblTfCheckInDate",
  CHECKINDATEMONTH = "lblTfCheckInDateMonth",
  CHECKINLINK = "lblTfCheckInLink",
  CHECKINTIME = "lblTfCheckInTime",
  CUSTOMERDROPOFFDATE = "lblTfCustomerDropOffDate",
  CUSTOMERDROPOFFTIME = "lblTfCustomerDropOffTime",
  CUSTOMEREMAIL = "lblTfCustomerEmail",
  CUSTOMERFIRSTNAME = "lblTfCustomerFirstName",
  CUSTOMERLASTNAME = "lblTfCustomerLastName",
  CUSTOMERMOBILECODE = "lblTfCustomerMobileCode",
  CUSTOMERMOBILENO = "lblTfCustomerMobileNo",
  CUSTOMERNAME = "lblTfCustomerName",
  CUSTOMERPICKUPDATE = "lblTfCustomerPickupDate",
  CUSTOMERPICKUPTIME = "lblTfCustomerPickupTime",
  DEALEREMAIL = "lblTfDealerEmail",
  DEALERMOBILECODE = "lblTfDealerMobileCode",
  DEALERMOBILENO = "lblTfDealerMobileNo",
  DEALERNAME = "lblTfDealerName",
  LICENSEPLATE = "lblTfLicensePlate",
  MECHANICEMAIL = "lblTfMechanicEmail",
  MECHANICNAME = "lblTfMechanicName",
  OWNERCUSTOMERNAME = "lblTfOwnerCustomerName",
  OWNERCUSTOMERNO = "lblTfOwnerCustomerNo",
  PLANNEDTIME = "lblTfPlannedTime",
  SERVICES = "lblTfServices",
  SERVICETIME = "lblTfServiceTime",
  STATUSTRACKERLINK = "lblTfStatusTrackerLink",
  USERCUSTOMERNO = "lblTfUserCustomerNo",
  VEHICLECHASSISNO = "lblTfVehicleChassisNo",
  VEHICLECOLOR = "lblTfVehicleColor",
  VEHICLEENGINESRNO = "lblTfVehicleEngineSrNo",
  VEHICLEFUELTYPE = "lblTfVehicleFuelType",
  VEHICLEKILOMETER = "lblTfVehicleKilometer",
  VEHICLEMODEL = "lblTfVehicleModel",
  VEHICLEMODELNO = "lblTfVehicleModelNo",
  VEHICLEPKKDATE = "lblTfVehiclePKKDate",
  VEHICLEREGDATE = "lblTfVehicleRegDate",
  VEHICLEREGLASTDATE = "lblTfVehicleRegLastDate",
  VEHICLETRANSMISSION = "lblTfVehicleTransmission",
  VEHICLETYPECODE = "lblTfVehicleTypeCode",
  VEHICLEYEAR = "lblTfVehicleYear",
  WARRANTYDOCNAME = "lblTfWarrantyDocName",
  WARRANTYDOCSIGNURL = "lblTfWarrantyDocSignUrl",
  WORKORDERNUMBER = "lblTfWorkOrderNumber",
  WORKORDERSTATUS = "lblTfWorkOrderStatus",
}

export enum ReasonType {
  OnHold = 1,
  Cancel = 2,
  Delete = 3
}

export enum jobStatus{
  Pending = "Pending",
  InProgress = "In Progress",
  Completed = "Completed"
}

export enum TimerType{
  StampInOut = 1,
  WorkOrder = 2,
  Job = 3,
  JobDetail = 4,
  TimeCode = 5
}
export enum MgDealerNo{
  oslo = "031027"
}

export enum AdditionalWorkStatus {
  All = 0,
  Reject = 1,
  Pending = 2,
  Approve = 3
}

export enum AttatchmentTypeEnums {
  DwoDemandAttachment = 1,
  DwoChecklistAttachment = 5,
  DwoAdditionalWorkAttachment = 8,
  DwoDiagnoseChecklistAttachment = 9,
  DwoParkingPositionAttachment = 6
}

export enum CheckInUsageReport{
  TotalAppointments = 1,
  SmsSentAppointments = 2,
  CheckInCompletedAppointments = 3,
  CheckInNotCompletedAppointments = 4,
  CheckInNotStartedAppointments = 5,
  SmsNotSentAppointments = 6,
  CheckInCompletedWithoutSmsAppointments = 7
}

export enum CheckInUsageReportStatus{
  TotalAppointments = "lblTotalAppointment",
  SmsSentAppointments = "lblSmsSent",
  CheckInCompletedAppointments = "lblCheckInCompleted",
  CheckInNotCompletedAppointments = "lblCheckInNotCompleted",
  CheckInNotStartedAppointments = "lblCheckInNotStarted",
  SmsNotSentAppointments = "lblSMSNotSent",
  CheckInCompletedWithoutSmsAppointments = "lblCheckInCompletedWithoutSms"
}